import { faTrash } from "@fortawesome/free-solid-svg-icons";
import type { FC } from "react";
import { useNavigate } from "react-router";
import { useApi } from "../api/APIContext";
import { useApiCall } from "../api/api";
import type { Exam } from "../api/dto";
import { ModalFooter } from "../components/layout/ModalProvider";

export const PermanentDeleteExamModal: FC<{ exam: Exam }> = (props) => {
  const navigate = useNavigate();
  const { refreshAll } = useApi();
  const { destroyExam } = useApiCall();
  const confirm = async () => {
    await destroyExam(props.exam.id);
    await refreshAll();
    navigate("/");
  };
  return (
    <>
      <div>Je staat op het punt om het volgende examen permanent te verwijderen.</div>
      <div className={"font-semibold my-2"}>
        &middot; <span>{props.exam.name}</span>
      </div>
      <div>
        Bij het uitvoeren van deze actie worden ook alle gerelateerde certificaten verwijderd
      </div>

      <div className={"mt-4 text-red-500"}>Let op! Deze actie valt niet terug te draaien.</div>
      <ModalFooter text={"Verwijder"} icon={faTrash} onSubmit={confirm} />
    </>
  );
};
